import * as _4 from 'lodash4';
import { ISection } from '../../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant } from '../../../../sections/servants/section_info_servant';
import { SchedulerCustomTextQuery } from '../../../../course_scheduler/queries/scheduler_custom_text_query';
import { RegistrationSectionPinsFacade } from '../../../facades/registration_section_pins_facade';

class MultiSectionPinCheckboxInput {
  private section: ISection;
  private multiSection: ISection[];
  private multiSectionCourse: ISection['_course'];

  constructor(
    private ngSectionInfoServant: SectionInfoServant,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private ngRegistrationSectionPinsFacade: RegistrationSectionPinsFacade
  ) {}
  $onInit() {
    /**
     * multiSection shares the same PIN, so we can use the first section for Section Pins logic
     */
    this.section = this.multiSection[0];
    this.multiSectionCourse = this.multiSection[0]._course;
  }
}

angular.module('capability-ng-scheduler').component('multiSectionPinCheckboxInput', {
  bindings: {
    multiSection: '<',
    form: '@'
  },
  templateUrl:
    'capability-ng-scheduler/src/views/registration/components/registration_pins/multi_section_pin_checkbox_input/multi_section_pin_checkbox_input.html',
  controller: MultiSectionPinCheckboxInput
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pins/multi_section_pin_checkbox_input/multi_section_pin_checkbox_input.ts